import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Select, message } from 'antd';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { getOTACodes } from './../../../../../services/common';
import { saveOrUpdatePolicyCommission } from './../../../../../services/policy';
import Loading from './../../../../Loading';

interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any,
    setOperationType: void | any,
    detailData: any,
    supplier: string,
    propertyid: string,
    getPoliciesData: () => {},
    setPoliciesData: void | any
}

const FormItem = Form.Item
const Option = Select.Option
const CommissionDetail = (props: propsTypes) => {
    const [currentOptions, setCurrentOptions] = useState<{ id: number, codeType: string, codeValue: string, codeName: string, subCat: any }[]>([])
    const [loadingFlag, setLoadingFlag] = useState(false)
    const [disableFlag, setDisableFlag] = useState(false)
    const [disableDelete, setDisableDelete] = useState(true)
    const getCurrentOptions = async () => {
        const res = await getOTACodes('CUR', '')
        if (res.result.success) {
            setCurrentOptions(res.otacodes)
        } else {
            setCurrentOptions([])
        }
    }
    const validateForm = () => {
        form.validateFields().then(() => {
            setDisableFlag(false)
        }).catch(err => {
            err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
        });
    }
    const [chargeName, setChargeName] = useState<any>(`Commission (${props?.detailData?.policies?.commissionpolicy?.type || ''})`);
    const [form] = Form.useForm()

    const updateCommission = () => {
        form.validateFields().then(values => {
            setLoadingFlag(true)
            const requestBody = {
                supplier: props.supplier,
                propertyId: props.propertyid,
                property: {
                    policies: {
                        commissionpolicy: {
                            commissionid: values.commissionid,
                            commissionlangid: values.commissionlangid,
                            description: values.description,
                            type: values.type,
                            charge: values.charge,
                            currency: values.currency,
                            paymentcompany: values.paymentcompany,
                            taxinclusive: values.taxinclusive,
                            commissionhcc: values.commissionhcc
                        }
                    }
                }
            }
            saveOrUpdatePolicyCommission(requestBody).then(
                res => {
                    if (res.result.success) {
                        setLoadingFlag(false)
                        props.cancelEditable();
                        props.setOperationType('view');
                        props.setPoliciesData(null)
                        props.getPoliciesData();
                    } else {
                        setLoadingFlag(false)
                        message.error({
                            content: res?.error[0]?.message || 'operation failed'
                        });
                    }

                },
                err => {
                    setLoadingFlag(false)
                    message.error({
                        content: err?.message || err?.error[0]?.message
                    });
                    props.cancelEditable();
                    // props.setOperationType('view');
                    // props.setPoliciesData(null)
                    // props.getPoliciesData();
                }
            )

        })

    }


    const shouldDisableDelete = () => {
      
      const commissionpolicy =  props?.detailData?.policies?.commissionpolicy
      if (commissionpolicy.commissionid && commissionpolicy.commissionlangid ){
        Object.keys(commissionpolicy).forEach((key)=>{
          if(key === "commissionid" || key === "commissionlangid"){
            return;
          }
          if(commissionpolicy[key]) {
            setDisableDelete(false) // enable delete if you have a field
            return;
          };
        })
      }
      
    }

    const onDelete = () =>{
      const requestBody = {
        supplier: props.supplier,
        propertyId: props.propertyid,
        property: {
            policies: {
                commissionpolicy: {
                    commissionid:props?.detailData?.policies?.commissionpolicy.commissionid,
                    commissionlangid: props?.detailData?.policies?.commissionpolicy.commissionlangid,
                    description: '',
                    type: '',
                    charge: '',
                    currency: '',
                    paymentcompany: '',
                    taxinclusive: '',
                    commissionhcc: ''
                }
            }
        }
    }

    
    saveOrUpdatePolicyCommission(requestBody).then(
      res => {
          if (res.result.success) {
              setLoadingFlag(false)
              props.cancelEditable();
              props.setOperationType('view');
              props.setPoliciesData(null)
              props.getPoliciesData();
          } else {
              setLoadingFlag(false)
              message.error({
                  content: res?.error[0]?.message || 'operation failed'
              });
          }

      },
      err => {
          setLoadingFlag(false)
          message.error({
              content: err?.message || err?.error[0]?.message
          });
          props.cancelEditable();
          // props.setOperationType('view');
          // props.setPoliciesData(null)
          // props.getPoliciesData();
      }
  )
    }

    useEffect(() => {
        getCurrentOptions()
        validateForm();
        shouldDisableDelete()
        
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    return (
      <>
        <PageContainer>
          <Card 
            style={{ marginTop: -15 }} 
            title='Commission'
            headStyle={{ fontWeight: 600, fontSize: 14, color: '#333', paddingTop: '8px' }}
            >
            <div style={{ padding: '0 20px' }}>
              <Form
                form={form}
                layout='vertical'
                initialValues={{
                  ...props?.detailData?.policies?.commissionpolicy,
                }}
                onValuesChange={validateForm}>
                <Row gutter={24}>
                  <FormItem name='commissionid' style={{ display: 'none' }}>
                    <Input />
                  </FormItem>
                  <FormItem name='commissionlangid' style={{ display: 'none' }}>
                    <Input />
                  </FormItem>
                  <Col span={6}>
                    <FormItem name='type' label='Commission Type'>
                      <Select allowClear onChange={(value) =>
                          setChargeName(`Commission (${value})`)
                        }
                        showSearch>
                        <Option value='Percent'>Percent</Option>
                        <Option value='Amount'>Amount</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      name='charge'
                      label={chargeName}
                      rules={[
                        { required: true, message: 'This field is required' },
                        {
                          pattern: /^\d*(\.\d*)?$/,
                          message: 'This field should be a number.',
                        },
                      ]}>
                      <Input />
                    </FormItem>
                  </Col>
                  <>
                    {chargeName === 'Commission (Amount)' && (
                      <>
                        <Col span={6} className='col-margin'>
                          <FormItem
                            name='currency'
                            label='Currency'
                            rules={[
                              {
                                required: true,
                                message: 'This field is required',
                              },
                            ]}>
                            <Select allowClear showSearch
                              placeholder='Select a currency'
                              optionFilterProp='children'
                              // @ts-expect-error
                              filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }>
                              {currentOptions.map((item: any) => (
                                <Option
                                  value={item.codeName}
                                  key={item.codeValue}>
                                  {item.codeName}
                                </Option>
                              ))}
                            </Select>
                          </FormItem>
                        </Col>
                      </>
                    )}
                  </>
                  <Col span={18}>
                    <FormItem
                      name='description'
                      label='Description'
                      rules={[
                        {
                          max: 300,
                          message:
                            'You have reached the max character length of 300',
                        },
                      ]}>
                      <TextArea maxLength={300} minRows={3} />
                    </FormItem>
                  </Col>
                  <Col span={6}></Col>
                  <Col span={6}>
                    <FormItem name='paymentcompany' label='Payment Company'>
                      <Select allowClear showSearch>
                        <Option value='Bass Hotels - BH'>
                          Bass Hotels - BH
                        </Option>
                        <Option value='Bestcheque - BW'>Bestcheque - BW</Option>
                        <Option value='Centralized Programs - YE'>
                          Centralized Programs - YE
                        </Option>
                        <Option value='Marriott Brands - MI'>
                          Marriott Brands - MI
                        </Option>
                        <Option value='Millennium Copthorne Commission Program - MU'>
                          Millennium Copthorne Commission Program - MU
                        </Option>
                        <Option value='No Programs - NO'>
                          No Programs - NO
                        </Option>
                        <Option value='NPC/National Prod Co - WZ'>
                          NPC/National Prod Co - WZ
                        </Option>
                        <Option value='Onyx Program - OX'>
                          Onyx Program - OX
                        </Option>
                        <Option value='Travel Agent Commission Settlement - TACS'>
                          Travel Agent Commission Settlement - TACS
                        </Option>
                        <Option value='TravelCom - TC'>TravelCom - TC</Option>
                        <Option value='WPS / Worldwide Payment Systems - WP'>
                          WPS / Worldwide Payment Systems - WP
                        </Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      name='commissionhcc'
                      label='Commission Settled Via HCC'>
                      <Select allowClear showSearch>
                        <Option value='true'>Yes</Option>
                        <Option value='false'>No</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      name='taxinclusive'
                      label='Commission Inclusive of Tax'>
                      <Select allowClear showSearch>
                        <Option value='true'>Yes</Option>
                        <Option value='false'>No</Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </div>
          </Card>
          <ActionButtonsBar
            onCancel={() => {
              props.cancelEditable()
              props.setOperationType('view')
            }}
            onSave={updateCommission}
            onDelete={onDelete}
            disabledDelete={disableDelete}
            disabledSave={disableFlag}
          />
        </PageContainer>
        {loadingFlag && (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
            }}>
            <Loading type='large' />
          </div>
        )}
      </>
    )
}

export default CommissionDetail;



